import { AbstractControl, ValidatorFn } from '@angular/forms';
import { QuestionItem } from '../models/task-model';

export function allowedValueValidator(questionsData: QuestionItem[]): ValidatorFn {
  return (control: AbstractControl) => {
    const value = control.value as QuestionItem;

    if (!value || !value.id) {
      return { invalidQuestion: true };
    }

    const isValid = questionsData.some(q => q.id === value.id);

    return isValid ? null : { invalidQuestion: true };
  };
}


